var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddToCartNotification',{attrs:{"notifications":_vm.notificationsByArea.default}}),_vm._v(" "),_c('InfoNotification',{attrs:{"notifications-top":_vm.notificationsByArea.top}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }